module.exports = __webpack_public_path__ + "static/media/promotions.2cef306d.svg";